// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import SocialEventEmailType from "enums/SocialEventEmailType";
import Util from "PreciateUtil";

export default interface SocialEventEmail {
    type?: SocialEventEmailType;
    subject?: string;
    fromName?: string;
    preHeader?: string;
    message?: string;
    buttonVisible?: boolean;
    buttonText?: string;
    buttonLink?: string;
    buttonColor?: string;
    buttonTextColor?: string;
    sentDateTime?: Date;
    automatic?: boolean;
    enabled?: boolean;
}

export function processSocialEventEmail(value?: SocialEventEmail): void {
  if (value) {
    value.sentDateTime = Util.toDate((value as any).sentDateTime);
  }
}

export function processSocialEventEmailArray(array?: SocialEventEmail[]): void {
  if (array) {
    for (const v of array) {
      processSocialEventEmail(v);
    }
  }
}
